/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import PropTypes from "prop-types";
import React from "react";
import { ListComponent } from "@quintype/arrow";
import get from "lodash/get";
import { useSelector } from "react-redux";
import { defaultPremiumIconColor, defaultTheme, defaultDarkTheme } from "../../../constants";

import "./search-page.m.css";

export const SearchPageResults = ({ collection, config, getMoreStories, limit, hideLoadmore, builderConfig }) => {
  const pbUpdatedConfig = builderConfig || get(config, ["pagebuilder-config"]);
  const pbSearchConfig = get(pbUpdatedConfig, ["search", "pageSetting", "searchResultsConfig"], {});
  const sectionTagTemplate = get(
    pbUpdatedConfig,
    ["general", "rows", "sectionTag", "template"],
    get(pbSearchConfig, ["sectionTagTemplate"], "solid")
  );
  const footerButton = get(pbSearchConfig, ["footerButton"], "SubsequentLoadCount");
  const showRowTitle = false;
  const enableDarkMode = useSelector((state) => get(state, ["header", "isDarkModeEnabled"], false));
  const fallbackImageUrl = get(pbUpdatedConfig, ["general", "fallbackImage", "url"]);
  const {
    enablePremiumStoryIcon = false,
    iconColor = defaultPremiumIconColor,
    iconStyle = "star",
    darkIconColor = defaultPremiumIconColor,
  } = get(pbUpdatedConfig, ["general", "rows", "premiumStoryIcon"], {});
  const premiumStoryIconConfig = {
    enablePremiumStoryIcon,
    iconColor: enableDarkMode ? darkIconColor : iconColor,
    iconStyle,
  };

  const { enableLocalization = false, localizedElements = {} } = get(pbUpdatedConfig, ["general", "localization"], {});

  const { months, meridiem, publishTime, buttonLabels = {} } = localizedElements;
  const { timeToRead } = buttonLabels;
  const localizationConfig = enableLocalization
    ? {
        localizedTimeToRead: timeToRead,
        localizedMonths: months,
        localizedMeridiem: meridiem,
        localizedPublishTime: publishTime,
      }
    : {};

  const borderColor = enableDarkMode
    ? get(pbUpdatedConfig, ["general", "rows", "sectionTag", "darkColor"], "#4860BC")
    : get(pbUpdatedConfig, ["general", "rows", "sectionTag", "color"], "");
  return (
    <ListComponent
      collection={collection}
      config={{
        theme: enableDarkMode ? defaultDarkTheme : defaultTheme,
        ...pbSearchConfig,
        sectionTagTemplate,
        borderColor,
        showRowTitle,
        footerButton,
        fallbackImageUrl,
        ...premiumStoryIconConfig,
        localizationConfig,
      }}
      getMoreStories={getMoreStories}
      hideButton={hideLoadmore}
      limit={limit}
      authorPrefix=""
    />
  );
};

SearchPageResults.propTypes = {
  collection: PropTypes.any,
  getMoreStories: PropTypes.func,
  limit: PropTypes.number,
  hideLoadmore: PropTypes.bool,
  builderConfig: PropTypes.object,
  config: PropTypes.shape({
    collectionNameBorderColor: PropTypes.string,
    borderColor: PropTypes.string,
    theme: PropTypes.string,
    border: PropTypes.string,
    collectionNameTemplate: PropTypes.string,
    footerButton: PropTypes.string,
    initialLoadCount: PropTypes.string,
    getLoadMore: PropTypes.func,
    "pagebuilder-config": PropTypes.object,
  }),
};
